import * as React from 'react';
import './header.scss';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import 'rc-menu/assets/index.css';
import { getAdminConfigTableItem } from '../_global/utility/adminConfigUtils';
export interface NavSubMenu {
  children: Array<any>;
  customUrl: string;
  expanded: boolean;
  isHeading: boolean;
  newTab: boolean;
  protocol: string;
  route: string;
  title: string;
} 
interface NavMenuItem {
  customUrl: string;
  isHeading: boolean;
  newTab: boolean;
  protocol: string;
  route: string;
  title: string;
} 
function handleClick(info: any) {
  console.log(`clicked ${info.key}`);
  console.log(info);
}
export interface HeaderNavProps {
  mode?: 'inline' | 'horizontal' | 'vertical' | 'vertical-left' | 'vertical-right' | undefined;
  openAnimation?: string | object;
  triggerSubMenuAction?: string;
  defaultOpenKeys?: [string];
  updateChildrenAndOverflowedIndicator?: boolean;
  clientConfig: any;
  adminConfig: any;
  pageHeaderAdminData?: any; 
}
export class HeaderNav extends React.Component<HeaderNavProps> {
  state = {
    overflowedIndicator: undefined,
  };
  componentDidMount() {
    this.cleanupDivs();
  }
  cleanupDivs = () => {
    var elts = document.querySelectorAll('div.rc-menu-submenu-title');
  
    for (var e = 0; e < elts.length; e++) { // For each element
       var elt = elts[e];
       elt.removeAttribute('aria-expanded');
    }
  }
  render() {
    const { overflowedIndicator } = this.state;
    const pageHeaderAdminData = this.props.pageHeaderAdminData;
    let navMenu: any = [];
    let subMenuKey = 1;
    let menuItemKey = 0;
    if (pageHeaderAdminData.Navigation !== undefined) {
      pageHeaderAdminData.Navigation.forEach((navItem: NavSubMenu) => {
     
        navMenu.push(
          <SubMenu
            key={subMenuKey}
            title={<span className="submenu-title-wrapper">{navItem.customUrl ? <a href={navItem.protocol + navItem.customUrl} 
            target={navItem.newTab ? '_blank' : ''}>{navItem.title}</a> : navItem.title}</span>} 
          >
  
          {navItem.children !== undefined &&  (
            navItem.children.map((childItem: NavMenuItem) => {
              menuItemKey++;
              return <MenuItem key={subMenuKey + '-' + menuItemKey}  title={childItem.title}>
              {childItem.customUrl ? <a href={childItem.protocol + childItem.customUrl} target={childItem.newTab ? '_blank' : ''}>
              <span className="submenu-title-wrapper">{childItem.title}</span></a> : childItem.title}
              </MenuItem> ;
            })
          )}
          </SubMenu>,
        );
        subMenuKey++;
        menuItemKey = 0;
      });
    }

    return (
      <div>
        <Menu
          // onClick={handleClick}
          triggerSubMenuAction={'hover'}
          // onOpenChange={onOpenChange}
          // selectedKeys={['1']}
          mode={this.props.mode}
          role={'menubar'}
          // openAnimation={animation}
          overflowedIndicator={overflowedIndicator}
          className={'rc-menu'}
        >

        {navMenu}
        </Menu>
      </div>
    );
  }
}
